export default function TermsConditions() {
  return (
    <div className="mx-auto max-w-4xl rounded-lg px-6 py-[60px] md:py-[80px] lg:py-[100px]">
      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">1. Introduction</h2>
        <p className="mb-4">
          ProxyMed provides telehealth services through licensed medical
          professionals. By using our services, you agree to these Terms &
          Conditions.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">2. Use of Services</h2>
        <p className="mb-2">Your data is used to:</p>
        <ul className="list-disc space-y-2 pl-8">
          <li>
            Eligibility: You must be 18 years or older (or have parental
            consent).
          </li>
          <li>
            U.S. Residents Only: Our services are available to residents of the
            United States.
          </li>
          <li>
            Account Responsibility: You must provide accurate health and
            personal information.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">3. Payment & Refund Policy</h2>
        <ul className="list-disc space-y-2 pl-8">
          <li>Payments: Consultation fees must be paid before appointments.</li>
          <li>
            Refunds: Refunds are only issued for incomplete or canceled
            services.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">4. Prescription Policy</h2>
        <ul className="list-disc space-y-2 pl-8">
          <li>ProxyMed providers may prescribe non-controlled medications.</li>
          <li>
            We do not prescribe controlled substances, including opioids or
            benzodiazepines.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">5. Prohibited Activities</h2>
        <p className="mb-2">Users may not:</p>
        <ul className="list-disc space-y-2 pl-8">
          <li>Use ProxyMed for fraudulent activities.</li>
          <li>Provide false medical information.</li>
          <li>Attempt to access other users&apos; data.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">6. Limitation of Liability</h2>
        <p className="mb-2">ProxyMed is not responsible for:</p>
        <ul className="list-disc space-y-2 pl-8">
          <li>
            Misuse of medical advice provided during telehealth consultations.
          </li>
          <li>Delays in service due to technical issues.</li>
          <li>Any unforeseen medical complications.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">7. Governing Law</h2>
        <p>
          These Terms & Conditions are governed by U.S. federal and state laws.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">8. Contact Information</h2>
        <p>For legal inquiries, contact us at:</p>
        <p>Email: appointments@proxymedicine.com | Phone: +1 (888) 779-9633</p>
      </section>
    </div>
  );
}
